"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlarmingCharts = void 0;
require("core-js/modules/es.object.assign.js");
var _react = _interopRequireDefault(require("react"));
var _paulCorePackage = require("paul-core-package");
var _reactErrorBoundary = require("react-error-boundary");
var _AlarmingChartsInject = require("./AlarmingChartsInject");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const AlarmingCharts = exports.AlarmingCharts = (0, _reactErrorBoundary.withErrorBoundary)(_AlarmingChartsInject.AlarmingWrapChartsInject, {
  FallbackComponent: () => /*#__PURE__*/_react.default.createElement(_paulCorePackage.ErrorBox, _extends({}, _paulCorePackage.constants.errorComponent[_paulCorePackage.constants.errorType.critical], {
    className: "mx-auto"
  })),
  // eslint-disable-next-line no-console
  onError: (err, info) => console.error(err, info)
});